import PropTypes from 'prop-types'
import React from 'react'
import { Typography } from '@mui/material'
import Standard from '../../../src/css/images/Standard.svg'
import unverified from '../../../src/css/images/unverified.svg'
import fleetBusinessProfileImage from '../../css/images/Fleet-business-profile.svg'
import { useSelector } from 'react-redux'
import profileImage from '../../css/images/profile-image.svg'
import { Link } from 'react-router-dom'
// import { Chip } from '@mui/material';
// import ErrorHandle from '../ErrorHandle'
// import { ProfileApis } from '../../API/Login/ProfileApi'

export default function BusinessDetailsHeader({ businessProfileData }) {
    const {
        frProUser,
        followers,
        following,
        buddyList,
        emailVerified,
        numberVerified,
    } = useSelector((state) => state.Users)
    console.log(businessProfileData, '-----businessProfileData--->')
    return (
        <div className="align-items-start d-flex justify-content-between mb-5 flex-wrap">
            <div>
                <div className="d-flex flex-wrap">
                    <div className="image-holder-main position-relative">
                        <div className="image-holder overflow-hidden position-relative">
                            <img
                                src={businessProfileData?.profileImg || profileImage}
                                alt="profileImage"
                                height={160}
                                width={160}
                                style={{ objectFit: 'cover' }}
                            />
                        </div>
                    </div>
                    <div className="px-4 my-4 my-lg-0">
                        <img alt="" src={fleetBusinessProfileImage} />
                        {emailVerified && numberVerified ? (
                            <button className="verifedbutton" type="button">
                                <img src={Standard} alt="" />
                            </button>
                        ) : (
                            <button type="button">
                                <img src={unverified} alt="" />
                            </button>
                        )}

                        <h4 className="mt-2">
                            {businessProfileData?.businessName
                                ? businessProfileData?.businessName
                                : '-'}
                        </h4>
                        <p className="mb-0 small text-muted">
                            {frProUser?.updateProfileForm?.profileTagForm?.profileTag
                                ? frProUser?.updateProfileForm?.profileTagForm
                                    ?.profileTag
                                : 'No tag line added'}
                        </p>
                    </div>
                </div>
            </div>
            <div className="shadow-sm p-4 rounded-4 me-4 bg-white bg-white bg-white">
                <div className="text-theme mb-3">
                    <span className="me-3 fw-medium">
                        {buddyList?.length || 0} Buddies
                    </span>
                    <span className="me-3 fw-medium">
                        {followers?.length || 0} Followers
                    </span>
                    <span className="fw-medium">
                        {following?.length || 0} Following
                    </span>
                </div>
                <Typography
                    component={Link}
                    to="/BusinessUpdateProfile"
                    className="btn custom-button w-100"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                    >
                        <path
                            d="M14.6665 2.49993C14.8854 2.28106 15.1452 2.10744 15.4312 1.98899C15.7171 1.87054 16.0236 1.80957 16.3332 1.80957C16.6427 1.80957 16.9492 1.87054 17.2352 1.98899C17.5211 2.10744 17.781 2.28106 17.9998 2.49993C18.2187 2.7188 18.3923 2.97863 18.5108 3.2646C18.6292 3.55057 18.6902 3.85706 18.6902 4.16659C18.6902 4.47612 18.6292 4.78262 18.5108 5.06859C18.3923 5.35455 18.2187 5.61439 17.9998 5.83326L6.74984 17.0833L2.1665 18.3333L3.4165 13.7499L14.6665 2.49993Z"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                    </svg>{' '}
                    Edit my profile
                </Typography>
            </div>
        </div>
    )
}

BusinessDetailsHeader.propTypes = {
    businessProfileData: PropTypes.object,
}